module.exports = __webpack_public_path__ + "static/media/startRight.f363dbc3.svg";